import React, { useState } from 'react';
import DynamicFormBuilder from '../DynamicFormBuilder';

const CustomInputConfig = ({ config, onChange }) => {
  const [inputType, setInputType] = useState(config.inputType || 'new_opportunity');

  const inputTypes = {
    new_opportunity: {
      label: 'New Deal/Opportunity',
      fields: [
        { name: 'companyName', type: 'text', label: 'Company Name', required: true },
        { name: 'contactName', type: 'text', label: 'Contact Name', required: true },
        { name: 'dealValue', type: 'number', label: 'Deal Value ($)', required: false },
        { name: 'dealStage', type: 'select', label: 'Deal Stage', required: true,
          options: ['Prospecting', 'Qualified Lead', 'Proposal Stage', 'Negotiation'] },
        { name: 'closeDate', type: 'date', label: 'Expected Close Date', required: false },
        { name: 'description', type: 'textarea', label: 'Description', required: false }
      ]
    },
    competitor_mention: {
      label: 'New Competitor Alert',
      fields: [
        { name: 'competitorName', type: 'text', label: 'Competitor Name', required: true },
        { name: 'accountName', type: 'text', label: 'Account Name', required: true },
        { name: 'context', type: 'textarea', label: 'Context', 
          placeholder: 'Where was this mentioned?', required: false },
        { name: 'urgency', type: 'select', label: 'Urgency', required: true,
          options: ['Low', 'Medium', 'High', 'Critical'], default: 'Medium' },
        { name: 'productCategory', type: 'text', label: 'Product Category', required: false }
      ]
    },
    meeting_followup: {
      label: 'Meeting/Call Follow-up',
      fields: [
        { name: 'accountId', type: 'async-select', label: 'Account', 
          dataSource: '/api/custom-agents/trigger-data/accounts', required: true },
        { name: 'meetingType', type: 'select', label: 'Meeting Type', required: true,
          options: ['Discovery Call', 'Demo', 'Proposal Review', 'Check-in', 'Closing'] },
        { name: 'attendees', type: 'multiselect', label: 'Attendees',
          dataSource: '/api/custom-agents/trigger-data/contacts', required: false },
        { name: 'keyTakeaways', type: 'textarea', label: 'Key Takeaways', required: true },
        { name: 'nextSteps', type: 'textarea', label: 'Next Steps', required: true },
        { name: 'followUpDate', type: 'date', label: 'Follow-up Date', required: false }
      ]
    },
    content_request: {
      label: 'Content Generation Request',
      fields: [
        { name: 'contentType', type: 'select', label: 'Content Type', required: true,
          options: ['Email Draft', 'Proposal Section', 'Battle Card', 'Account Brief'] },
        { name: 'targetAccount', type: 'async-select', label: 'Target Account',
          dataSource: '/api/custom-agents/trigger-data/accounts', required: false },
        { name: 'targetContact', type: 'async-select', label: 'Target Contact',
          dataSource: '/api/custom-agents/trigger-data/contacts', required: false },
        { name: 'additionalContext', type: 'textarea', label: 'Additional Context', required: false },
        { name: 'tone', type: 'select', label: 'Tone', required: false,
          options: ['Professional', 'Friendly', 'Formal', 'Persuasive'], default: 'Professional' }
      ]
    },
    crm_sync: {
      label: 'CRM Sync Request',
      fields: [
        { name: 'crmType', type: 'select', label: 'CRM Type', required: true,
          options: ['HubSpot', 'Salesforce'] },
        { name: 'syncDirection', type: 'select', label: 'Sync Direction', required: true,
          options: ['Import to Velox', 'Export from Velox', 'Bi-directional'] },
        { name: 'objectType', type: 'select', label: 'Object Type', required: true,
          options: ['Accounts', 'Contacts', 'Deals', 'Activities'] },
        { name: 'recordId', type: 'text', label: 'Specific Record ID (Optional)', 
          placeholder: 'Leave empty to sync all', required: false }
      ]
    }
  };

  const currentInputType = inputTypes[inputType];

  const handleInputTypeChange = (newType) => {
    setInputType(newType);
    onChange({ 
      ...config, 
      inputType: newType, 
      formData: {},
      triggerData: { triggerType: newType }
    });
  };

  const handleFormDataChange = (formData) => {
    onChange({
      ...config,
      inputType,
      formData,
      triggerData: {
        triggerType: inputType,
        ...formData
      }
    });
  };

  return (
    <div className="custom-input-config">
      <div className="config-field">
        <label>Input Type</label>
        <select
          value={inputType}
          onChange={(e) => handleInputTypeChange(e.target.value)}
        >
          {Object.entries(inputTypes).map(([key, type]) => (
            <option key={key} value={key}>{type.label}</option>
          ))}
        </select>
      </div>

      <DynamicFormBuilder
        fields={currentInputType.fields}
        values={config.formData || {}}
        onChange={handleFormDataChange}
      />
    </div>
  );
};

export default CustomInputConfig;

